export type ToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

export const Toggle = ({ checked, onChange, disabled = false }: ToggleProps) => (
  <button
    type="button"
    onClick={() => !disabled && onChange(!checked)}
    class={`relative inline-flex items-center ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
    disabled={disabled}
    role="switch"
    aria-checked={checked}
  >
    <input type="checkbox" checked={checked} onChange={() => {}} class="sr-only peer" />
    <div
      class={`w-11 h-6 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 transition-colors ${
        checked ? "bg-blue-600" : "bg-gray-300 dark:bg-gray-600"
      }`}
    >
      <div class={`absolute top-[2px] bg-white w-5 h-5 rounded-full transition-all ${checked ? "left-[22px]" : "left-[2px]"}`} />
    </div>
  </button>
);
